import { Model, IApi, Api, moment, helper, IListItem, ITree } from '@smart/design';
import { id } from '../plugins/data-labels/labels-plugins';
import { REPORT_ID } from '../statics';

interface IConfig {
  apiURL: string;
}

interface IIdentifier {
  companyId: string;
}

class CustomTagModel extends Model<ITree, IConfig, string> {
  private api: IApi;

  public async initialize(config: IConfig) {
    this.api = Api.newApi(config.apiURL);
  }

  protected mapObject(obj: Array<{ name: string; id: string; colorTheme: string }>): ITree {
    return {
      id: 'root',
      isHidden: true,
      title: 'root',
      isRoot: true,
      children: obj.map(x => ({
        id: x.id,
        iconColor: x.colorTheme ?? '#000',
        title: x.name,
      })),
    };
  }
  protected async single(identifier: string) {
    const { data } = await this.api.get(
      `dashboard/companies/${identifier}/reports/${REPORT_ID}/custom-tags`
    );

    return {
      data,
      identifier,
    };
  }
}

export default new CustomTagModel('CustomTagModel');
